import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.onActivity = this.handleActivity.bind(this);
    document.addEventListener("text-message:activity", this.onActivity);
  }

  disconnect() {
    document.removeEventListener("text-message:activity", this.onActivity);
  }

  handleActivity(event) {
    this.showUnread();
    if (event.detail.inbound) this.dispatchLocalNotification();
  }

  get tab() {
    return document.querySelector(`.tabs-dashboard [data-tab="text-messages"]`);
  }

  removeUnread() {
    this.tab.classList.remove("unread");
  }

  showUnread() {
    const tab = this.tab;
    if (!tab.classList.contains("active")) {
      tab.classList.add("unread");
    }
  }

  dispatchLocalNotification() {
    if (document.visibilityState === "visible" && this.tab.classList.contains("active")) return;

    const controller = this.application.getControllerForElementAndIdentifier(
      document.querySelector("body"),
      "local-notification"
    );
    controller.notify({ detail: "New Notification Received" });
  }
}
